export default function DifferenceSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Our Difference
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            他の整体との違い
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-3xl p-10 border-2 border-gray-200">
              <div className="text-center mb-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gray-300 rounded-full mx-auto mb-4">
                  <i className="ri-hand-heart-line text-3xl text-gray-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-700 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>一般的な整体</h3>
              </div>
              <div className="space-y-4">
                {['痛い部分だけを揉む', 'その場は楽になる', '症状への対処が中心'].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-xl text-gray-500 flex-shrink-0 mt-1"></i>
                    <p className="text-base text-gray-600">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#10B981] to-[#059669] rounded-3xl p-10 shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
              <div className="relative z-10 text-center mb-8">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-4">
                  <i className="ri-heart-pulse-line text-3xl text-[#10B981]"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>アスロン整体</h3>
              </div>
              <div className="relative z-10 space-y-4">
                {['関節センサーを正常化', '施術後すぐ、あるいは時間が経つほど軽快', 'あらゆる疾患に対応'].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-xl text-white flex-shrink-0 mt-1"></i>
                    <p className="text-base text-white font-medium">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-12 bg-[#ECFDF5] rounded-3xl p-10 text-center">
            <p className="text-xl text-[#065F46] leading-relaxed" style={{ lineHeight: '2.0' }}>
              理学療法士の知識と整体の技術を組み合わせ、<br className="hidden md:block" />
              <strong className="font-bold">痛みが戻りにくい身体づくり</strong>を目指します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}